export default __webpack_public_path__ + "static/media/kubernetes_monitor.06be7cdf.md";